@if (canManageRoles()) {
  <a
    class="text-decoration-none"
    [routerLink]="['/app/custom-roles/builder', role().uuid, 'edit']"
    target="_blank"
    rel="noopener noreferrer"
    [slnkTooltip]="'fe.common.file_viewer.open_in_new_tab' | translate">
    <p-tag
      [value]="role().name"
      severity="secondary"
      [rounded]="true"
      [icon]="'arrow-up-right-from-square' | commonIcon" />
  </a>
} @else {
  <p-tag
    [value]="role().name"
    severity="secondary"
    [rounded]="true" />
}
